import React from 'react';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Select} from '../inspinia';
import Pagination from 'react-js-pagination';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { withRouter } from 'react-router-dom';

//MASK
import InputMask from 'react-input-mask';

//HELPERS
import * as c from '../../helpers/constants';
import { getToken } from '../../store/auth';
import { callApi } from '../../helpers/methods'
import { isBlank } from '../../helpers/stringHelper';

//REDUX
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

class AgendamentoDownload extends React.PureComponent{
    constructor(props){
        super(props);

        this.state={
            loading: true,
            form: {
                dataInicio: "",
                dataFim: "",
                filial : { id: 0 },
            },
            campanhaValues: {
                value: "",
                label: ""
            },
            comboNomeCampanhasAutoComplete: [],
            comboMailings: [],
            mailingValues: {
                value: "",
                label: ""
            },
            comboNomeCampanhas:
            {
                results: undefined
            }, 
            rotinaDisabled: false,
            list: 
            {
                currentPage: 0, pageNumber: 0, size: 0, totalElements: 0, content: undefined
            },
            comboEmpresa: 
            {
                results: undefined
            },
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
            alerta: withReactContent(Swal)
        }

        this.handleAgendar = this.handleAgendar.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.onNomeCampanhaChange = this.onNomeCampanhaChange.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.onNomeMailingChange = this.onNomeMailingChange.bind(this);
        this.LoadComboMailingsByEmpresa = this.LoadComboMailingsByEmpresa.bind(this);
        this.LoadComboMailingsByEmpresaData = this.LoadComboMailingsByEmpresaData.bind(this);
        this.onChangeNomeFilial = this.onChangeNomeFilial.bind(this);
    }

    handleChange(e) {
        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    componentDidMount() {
        this.LoadComboNomeCampanhas();
        this.LoadComboEmpresa();
        this.loadListaAgendamento();
    }

    LoadComboEmpresa() {
        const self = this;
        const data = JSON.stringify({
            'id_produto': null
        });
        const url = `${c.API_BASE_URL}/company-user`;
        const options =
        {
            method: 'POST'
            ,body: data
        };

        callApi(url, options, function (response) {
            self.setState({ ...self.state, comboEmpresa: response });
        });
    }

    LoadComboNomeCampanhas() {
        const self = this;

        const url = `${c.API_BASE_URL}/toi-campanhas`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({
                ...self.state,
                comboNomeCampanhas: response,
                comboNomeCampanhasAutoComplete: response.results
            });
        });
    }

    onNomeMailingChange = (event, values) => {
        const form = this.state.form;
        let mailingCombo = '';
        
        if (values) {
            mailingCombo = values.value;
        }
        
        this.setState({ form: { ...form, 'mailing': mailingCombo } });
        this.setState({ ...this.state, mailingValues: values });

    }

    LoadComboMailingsByEmpresa(empresa) {
        let self = this;        
        const url = `${c.API_BASE_URL}/mailing-list/` + empresa;
       
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboMailings: response });
        });
    }

    LoadComboMailingsByEmpresaData(empresa, dataIni, dataFim) {
        let self = this;
        let dataInicial = dataIni.split('/').reverse().join('-');
        let dataFinal = dataFim.split('/').reverse().join('-');

        const url = `${c.API_BASE_URL}/mailing-list/` + empresa + '/' + dataInicial + '/' + dataFinal;

        const _token = c.AUTH_HEADER(getToken());
       
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json', 'Authorization': _token },
        };

        self.setState({ ...self.state, loading: true });

        fetch(url, options).then(response => {
            let status = response.ok;
            response.json().then(resp => {
                if (status) {
                    self.setState({ ...self.state, loading: false, comboMailings: resp });
                } else {
                    this.state.alerta.fire({
                        icon: 'error',
                        title: 'Data incorreta',
                        html: resp.message,
                        confirmButtonColor: '#47A789',
                    });
                    self.setState({ ...self.state, loading: false });
                }
            });
        });
    }

    onNomeCampanhaChange = (event, values) => {
        const form = this.state.form;
        let campanhaCombo = '';
        
        if (values) {
            campanhaCombo = values.value;
        }
        
        this.setState({
            ...this.state,
            form: {
                ...form,
                'campanha': campanhaCombo
            },
            campanhaValues: values
        });
    }

    onChangeNomeFilial(event) {
        const form = this.state.form;
         
        if(event.target.options[event.target.selectedIndex].text == "Selecione..."){
            this.setState({ ...this.state, comboMailings: [] });
        }else if(form.dataInicio != "" && form.dataFim != ""){
            this.LoadComboMailingsByEmpresaData(event.target.options[event.target.selectedIndex].text, form.dataInicio, form.dataFim);
        }else{          
            this.LoadComboMailingsByEmpresa(event.target.options[event.target.selectedIndex].text);
        }    

        this.setState({ mailingValues: "" });  
        this.state.isLoggedIn = false;
        this.setState({
            form: {
                ...form,
                filial: {
                    id: event.target.value
                }
            }
        });
    }

    handleAgendar() {
        const self = this;
        const state = self.state;

        let idFilial = this.state.form.filial.id;

        if (isBlank(state.form.dataInicio)) {
            c.TOASTER_INFO("Data Início precisa ser preenchida.");
            return;
        }

        if (isBlank(state.form.dataFim)) {
            c.TOASTER_INFO("Data Fim precisa ser preenchida.");
            return;
        }

        if (idFilial === '' || idFilial == 0 || idFilial == "Selecione..." || idFilial == undefined) {
            c.TOASTER_INFO("Favor escolher uma filial.");
            return;
        }

        let mailing = null;
        if (state.mailingValues != "") {
            let mailingValue = state.mailingValues;
            mailing = mailingValue.value != "" ? mailingValue.value : null;
        }

        const url = `${c.API_BASE_URL}/agendarLaudos`;
        const _token = c.AUTH_HEADER(getToken());
        const options =
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': _token },
            body: JSON.stringify({
                dataInicio: state.form.dataInicio,
                dataFim: state.form.dataFim,
                filial: idFilial,
                idCampanha: state.campanhaValues === null ? null : state.campanhaValues.value,
                idMailing: mailing
              })
        };

        self.setState({ ...state, loading: true });

        fetch(url, options).then(async (response) => {
            response.json().then(resp => {
                if (resp.status === 200) {
                    c.TOASTER_SUCCESS(resp.message);
                } else {
                    c.TOASTER_ERROR(resp.message);
                }
    
                self.limparFormulario();
                self.loadListaAgendamento();
            })
        });
    }

    limparFormulario() {
        const state = this.state;

        const select = document.querySelector('select');
        select.value = "Selecione...";

        this.setState({
            ...state,
            form: {
                dataInicio: "",
                dataFim: "",
                filial: { id: 0 }
            },
            campanhaValues: {
                value: "",
                label: ""
            },
            mailingValues: {
                value: "",
                label: ""
            }
        })
    }
 
    loadListaAgendamento(pageNumber){
        const self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;

        const url = `${c.API_BASE_URL}/listarLaudos?page=${page}&size=${size}`;
        const options = self.state.optionsGet;

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, list: response, loading: false});
        });
    }
    
    handlePageChange(pageNumber){
        this.state.page = pageNumber;
        this.loadListaAgendamento(pageNumber);
    }

    render(){

        const campanhas = this.state.comboNomeCampanhasAutoComplete;
        const mailings = this.state.comboMailings;

        return (

            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-0">
                    <Column>
                        <IBox> 
                            <Title>
                                <h3 className="text-slate-grey">Agendar download</h3>
                            </Title>

                            <Content>
                                <Row>
                                        <Column size="2" className="p-1 mx-auto container">
                                            <label>Data Inicio:</label>
                                            <InputMask mask="99/99/9999" name="dataInicio" value={this.state.form.dataInicio} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" /> 
                                        </Column>

                                        <Column size="2" className="p-1 mx-auto container">
                                            <label>Data Fim:</label>
                                            <InputMask mask="99/99/9999" name="dataFim" value={this.state.form.dataFim} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />
                                        </Column>

                                        <Column size="2" className="p-1 mx-auto container">
                                            <label>Filial:</label>
                                            <Select name="filial" selected={this.state.form.filial.id} data={this.state.comboEmpresa} onChange={this.onChangeNomeFilial} placeholder="Filial"  />                                              
                                        </Column>

                                        <Column size="3" className="p-1 mx-auto container">
                                            <label>Rotina:</label>     
                                                <Autocomplete
                                                    id="combo-campanha"
                                                    options={campanhas}
                                                    getOptionLabel={(option) => option.label}
                                                    style={{marginTop:-8}}
                                                    onChange={this.onNomeCampanhaChange}
                                                    disabled={this.state.rotinaDisabled}
                                                    value={this.state.campanhaValues}
                                                    getOptionSelected={(option) => option.value}
                                                    renderInput={
                                                        (params) => 
                                                        <TextField 
                                                            {...params} 
                                                            variant="outlined"  
                                                            margin="dense"
                                                        /> 
                                                    }
                                                />
                                    </Column>
                                    <Column size="3" className="p-1 mx-auto container">
                                        <label>Mailing:</label>     
                                        <Autocomplete
                                            id="combo-mailing"
                                            options={mailings}
                                            getOptionLabel={(option) => option.label}
                                            style={{marginTop:-8}}                                           
                                            onChange={this.onNomeMailingChange}
                                            value={this.state.mailingValues}
                                            getOptionSelected={(option) => option.value}
                                            renderInput={
                                                (params) => 
                                                <TextField 
                                                    {...params} 
                                                    variant="outlined"  
                                                    margin="dense"
                                                /> 
                                            }
                                        /> 
                                    </Column>
                                </Row>

                                <Row className="m-0 mb-3">
                                <Column size="auto" className="mx-auto">
                                        <div className="input-group" >
                                            <Button className="mx-1" onClick={this.handleAgendar} disabled={this.state.loading} width="130px">Agendar</Button>

                                            <div className="ml-4">
                                                {this.state.loading && (
                                                    <CircularProgress
                                                        size={30}
                                                        thickness={4}
                                                        color='inherit'
                                                        variant='indeterminate' />
                                                )}
                                            </div>
                                        </div>
                                    </Column>
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this} buscar={this.state.buscar} loading={this.state.loading} />
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
                {/* FOOTER */}
                <Row className="mb-4">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.size}
                                        totalItemsCount={this.state.list.totalElements}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }
}

class Table extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selfMain: props.history,
            historyMain: props.history.props.history,
        }
    }


    render() {
        const loading = this.props.loading;
        const data = this.props.data;
        let html = "";

        if (loading)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando Agendamentos...</td></tr>);
        }
        else if (data.content === undefined || data.content.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.content.length > 0) {
            html = data.content.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.id}</td>
                    <td>{row.arquivo}</td>
                    <td>{row.dataAgendamento}</td>
                    <td>{row.dataInicio}</td>
                    <td>{row.dataFim}</td>
                    <td>{row.filial}</td>
                    <td>{row.status}</td>
                    <td><div style={{wordBreak: 'break-word', width: '190px'}}>{row.mailing}</div></td>
                    <td>{row.campanha}</td>
                </tr>
            );
        }

        return (
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{ backgroundColor: "#dbf1e9" }}>
                        <th>#</th>
                        <th>Arquivo</th>
                        <th>Data Agendamento</th>
                        <th>Data inicial</th>
                        <th>Data final</th>
                        <th>Filial</th>
                        <th>Status</th>
                        <th>Mailing</th>
                        <th>Rotina</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgendamentoDownload));